import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import Navbar from "./Navbar";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Status_Approval = () => {
    const [invoiceList, setInvoiceList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [modalData, setModalData] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const recordsPerPage = 10;

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");

        const fetchCategoriesList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getCategoriesList`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setCategoryList(data.data);

                    console.log('Doctors:', data);
                } else {
                    console.error('Data is not an array:', data);
                    setCategoryList([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchCategoriesList();
    }, []);

    const totalAmt = (modalData || []).reduce((sum, row) => sum + (parseFloat(row.amt) || 0), 0);

    const getTestCategoryById = (categoryId) => {
        const category = categoryList.find(cat => cat.id === categoryId);
        return category ? category.test_category : 'Unknown Category';
    };

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        const fetchInvoices = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getDoctorPending`, {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setInvoiceList(data.data);
                } else {
                    console.error("Data is not an array:", data);
                    setInvoiceList([]);
                }
            } catch (error) {
                console.error("Error fetching invoices:", error);
            }
        };
        fetchInvoices();
    }, []);

    const handleStatusChange = async (inv_no, newStatus) => {
        const token = localStorage.getItem("jwt_token");
        try {
            const response = await fetch(`${API_BASE_URL}api/update_status`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ inv_no, status: newStatus }),
            });

            if (!response.ok) {
                throw new Error("Failed to update status");
            }

            setInvoiceList(prevList =>
                prevList.map(invoice =>
                    invoice.inv_no === inv_no ? { ...invoice, inv_status: newStatus } : invoice
                )
            );
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    const filteredData = invoiceList.filter(item =>
        item.inv_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.doct_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.paymode.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const goToPage = (pageNumber) => setCurrentPage(pageNumber);

    const handleRowClick = async (reportingRadiologistBMID, fromdate, todate) => {
        const token = localStorage.getItem("jwt_token");

        console.log("Fetching invoice for BMID:", reportingRadiologistBMID);
        // console.log("Selected Month (Index):", selectedMonth);
        // console.log("Selected Year:", selectedYear);
        console.log("API URL:", `${API_BASE_URL}api/getDoctorsInvoiceByid/${reportingRadiologistBMID}/${fromdate}/${todate}`);

        try {
            const response = await fetch(`${API_BASE_URL}api/getDoctorsApprovalsData/${reportingRadiologistBMID}/${fromdate}/${todate}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log("Response Status:", response.status);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch detailed invoice data: ${errorText}`);
            }

            const data = await response.json();
            console.log("Fetched Invoice Data:", data);

            if (data?.data) {
                setModalData(data.data); // Set fetched data into the modal
                setShowModal(true);      // Show modal
            } else {
                console.warn("No data received from API");
            }
        } catch (error) {
            console.error("Error fetching invoice by ID:", error);
        }
    };

    const downloadExcel = () => {
        if (!modalData || modalData.length === 0) return;

        // Define column headers and map data accordingly
        const wsData = [
            [
                "#",
                "Register Date",
                "Branch",
                "Lab ID",
                "Patient Name",
                "Service ID",
                "Service Name",
                "Amount",
                "Amount Type",
                "Target",
                "Study Desc",
                "Main Category"
            ],
            ...modalData.map((row, index) => [
                index + 1,
                row.register_date,
                row.branch,
                row.labid,
                row.patient_name,
                row.service_id,
                row.service_name,
                row.amt,
                row.amt_type,
                row.target,
                row.study_desc,
                getTestCategoryById(row.Main_category) // Assuming this function returns a readable category name
            ])
        ];

        // Create a worksheet
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Create a workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Detailed Invoice");

        // Save the Excel file
        XLSX.writeFile(wb, "detailed_invoice.xlsx");
    };


    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <Navbar />
                <div className="content-inner container-fluid pb-0">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4">
                                    <h4 className="card-title">Doctor Invoice Approval</h4>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-25"
                                        placeholder="Search by Invoice No, Doctor Code, Pay Mode"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Invoice No</th>
                                        <th>Invoice Date</th>
                                        <th>Doctor Code</th>
                                        <th>Doctor Name</th>
                                        <th>Invoice Period</th>
                                        <th>Month</th>
                                        <th>Year</th>
                                        <th>Processed Amount</th>
                                        <th>Lop Amount</th>
                                        <th>Lop Days</th>
                                        <th>Time Deviation Days</th>
                                        <th>Time Deviation Minutes</th>
                                        <th>Time Deviation Amount</th>
                                        <th>Payment Mode</th>
                                        <th>No. of Cases</th>
                                        <th>Invoice Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRecords.length > 0 ? (
                                        currentRecords.map((invoice, index) => {
                                            const date = new Date(invoice.inv_from);
                                            const monthName = date.toLocaleString('en-US', { month: 'long' });
                                            const monthIndex = date.getMonth();
                                            const year = date.getFullYear();

                                            return (
                                                <tr key={invoice.inv_no}>
                                                    <td>{indexOfFirstRecord + index + 1}</td>
                                                    <td>{invoice.inv_no}</td>
                                                    <td>{invoice.inv_date}</td>
                                                    <td
                                                        onClick={() => handleRowClick(invoice.doct_code, invoice.inv_from, invoice.inv_to)}
                                                        style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}
                                                    >
                                                        {invoice.doct_code}
                                                    </td>
                                                    <td>{invoice.comp_name}</td>
                                                    <td>{invoice.inv_from} - {invoice.inv_to}</td>
                                                    <td>{monthName}</td>
                                                    <td>{year}</td>
                                                    <td>{invoice.process_amt}</td>
                                                    <td>{invoice.lop_amount}</td>
                                                    <td>{invoice.lop_days}</td>
                                                    <td>{invoice.time_deviation_days}</td>
                                                    <td>{invoice.time_deviation_minutes}</td>
                                                    <td>{invoice.time_deviation_amount}</td>
                                                    <td>{invoice.paymode}</td>
                                                    <td>{invoice.no_of_cases}</td>
                                                    <td className="position-relative">
                                                        <div className="position-relative">
                                                            <select
                                                                className={`form-control form-control-sm pe-5 appearance-none ${invoice.inv_status === "Approved"
                                                                    ? "text-white bg-success"
                                                                    : invoice.inv_status === "Rejected"
                                                                        ? "text-white bg-danger"
                                                                        : "text-dark bg-warning"
                                                                    }`}
                                                                value={invoice.inv_status || "Pending"}
                                                                onChange={(e) => handleStatusChange(invoice.inv_no, e.target.value)}
                                                                style={{ appearance: "none" }} // Hide default browser arrow
                                                            >
                                                                <option className="text-dark bg-warning" value="Pending">Pending</option>
                                                                <option className="text-white bg-success" value="Approved">Approved</option>
                                                                <option className="text-white bg-danger" value="Rejected">Rejected</option>
                                                            </select>

                                                            {/* Dropdown Icon */}
                                                            <i className="bi bi-chevron-down position-absolute"
                                                                style={{
                                                                    right: "12px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    pointerEvents: "none",
                                                                    color: "#000", // Change color if needed
                                                                }}>
                                                            </i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">No records found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {/* Modal for displaying detailed data */}
                            {showModal && modalData && (
                                <div className="modal" style={{ display: 'block', overflow: 'hidden', zIndex: 9999 }}>
                                    <div
                                        className="modal-content"
                                        style={{
                                            padding: '20px',
                                            maxWidth: '80%',
                                            margin: 'auto',
                                            backgroundColor: '#fff',
                                            borderRadius: '10px',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                            maxHeight: '80vh', // Limit modal height
                                            overflow: 'hidden', // Hide overflow on the modal
                                        }}
                                    >
                                        <span
                                            className="close"
                                            onClick={() => setShowModal(false)}
                                            style={{
                                                float: 'right',
                                                cursor: 'pointer',
                                                fontSize: '30px',
                                                color: '#aaa',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            &times;
                                        </span>
                                        <h2 style={{ textAlign: 'center', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                            Detailed Invoice
                                            <FaDownload
                                                style={{ cursor: "pointer", color: "#007bff", fontSize: "24px" }}
                                                onClick={downloadExcel}
                                                title="Download Excel"
                                            />
                                        </h2>
                                        {/* Render modal data in a table */}
                                        <div
                                            style={{
                                                width: '100%',
                                                overflow: 'auto',
                                                maxHeight: '60vh', // Set max height for the table
                                                border: '1px solid #ddd',
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            <table
                                                style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse',
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            #
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Register date
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Branch
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Lab ID
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Patient Name
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Service ID
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Service Name
                                                        </th>

                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Amount
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Amount Type
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Target
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Study Desc
                                                        </th>
                                                        <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                            Main Category
                                                        </th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modalData.map((row, index) => (
                                                        <tr key={row.id}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {index + 1}
                                                            </td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.register_date}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.branch}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.labid}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.patient_name}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.service_id}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.service_name}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.amt}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.amt_type}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.target}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.study_desc}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{getTestCategoryById(row.Main_category)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="6" style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total:</td>
                                                        <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>{totalAmt}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Status_Approval;
